import Vue from 'vue'
import ItemData from 'src/assets/ItemData'
import api from 'src/assets/api/gql'
import Subscription from 'src/assets/api/Subscription'
import ItemSubscription from 'src/graphql/item/ItemSubscription.gql'
import ItemUpdateData from 'src/graphql/item/ItemUpdateData.gql'

import * as Y from 'yjs'
import { base64ToBytes, bytesToBase64 } from 'byte-base64'

export interface ItemDataUpdate {
  infoSettings?: Json,
  infoTexts?: { [key: string]: string[] },
  slidesSettings?: Json,
  slidesTexts?: { [key: string]: string[] },
  slidesCorrects?: Json
}

export default class ItemDataLive extends ItemData {
  itemId!: number
  subscription!:  Subscription

  constructor (itemId: number, subscription?:  Subscription) {
    super({})
    this.itemId = itemId
    if (subscription) {
      this.subscription = subscription
    } else {
      this.subscription = new Subscription(ItemSubscription, { itemId })
      this.subscription.start((data: any) => {
        const init = data?.item?.init
        if (init) {
          this.update(init.data || {})
        }
        const payload = data?.item?.payload
        if (payload) {
          this.update(payload.data || {})
        }
      })
    }
  }

  destroy () {
    this.subscription.end()
  }

  update (itemDataUpdate: ItemDataUpdate) {
    this.updateProperties(this.info, itemDataUpdate.infoSettings || {})
    this.updateTextsLive('infoTexts', this.info, itemDataUpdate.infoTexts || {})
    this.updateProperties(this.slides, itemDataUpdate.slidesSettings || {})
    this.updateTextsLive('slidesTexts', this.slides, itemDataUpdate.slidesTexts || {})
    this.updateProperties(this.corrects, itemDataUpdate.slidesCorrects || {})
  }

  updateTextsLive (dataName: string, target: { [key: string]: Json }, updates: { [key: string]: string[] }) {
    for (const [key, value] of Object.entries(updates)) {
      const path = key.split(':')
      const pathtarget = this.getPathTarget(target, path)
      const property = path.pop()
      if (property) {
        if (value === null) {
          Vue.delete(pathtarget, property)
        } else {
          if (pathtarget[property] === undefined) {
            Vue.set(pathtarget, property, this.getDoc(dataName, key))
          }
          const doc = pathtarget[property] as Y.Doc
          for (const update of value) {
            Y.applyUpdate(doc, base64ToBytes(update), 'REMOTE')
          }
        }
      }
    }
  }

  getPathTarget (target: { [key: string]: Json }, path: string[]) {
    while (path.length > 1) {
      const property = path.shift()
      if (property) {
        if (!target[property]) {
          Vue.set(target, property, {})
        }
        target = target[property]
      }
    }
    return target
  }

  getDoc(dataName: string, dataPathKey: string) {
    const doc = new Y.Doc()
    doc.on('update', (update: Uint8Array, origin: any) => {
      if (origin !== 'REMOTE') {
        const value: Json = {}
        value[ dataPathKey ] = [bytesToBase64(update)]
        const patch: Json = {}
        patch[ dataName ] = value
        this.save(patch)
      }
    })
    return doc
  }

  async save (data: ItemDataUpdate) {
    await api.mutate({
      query: ItemUpdateData,
      variables: {
        input: { id: this.itemId, data }
      }
    })
  }
}
